const MessageText = ({text}) => {
    const linkify = (text) => {
        const urlRegex = /\b(https:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}[-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
        let parts = text.split(urlRegex) // re is a matching regular expression
        for (let i = 1; i < parts.length; i += 2) {
            parts[i] = <a key={'link' + i} href={parts[i]} target="_blank" rel="nofollow noopener">{parts[i]}</a>;
        }
        return parts
    }
    return <div className='message-text'>{linkify(text)}</div>
}

export default MessageText;